import { MDSIconKind } from "@/mds";

export const SMART_VIEW_ICON_KIND = MDSIconKind.SplitPanel;
